import { getLocalStorage } from '@/utils/localStrage';
import { LocalStorageKeys } from '@/constants/localStorage';

/**
 * モードをローカルストレージから取得
 * @param userId ユーザーID
 * @returns モード
 */
export async function getTimeMode(
    userId: string | number,
    storageKey: string = LocalStorageKeys.TIME_COUNTDOWN_STATE,
): Promise<string | null> {
    return await getLocalStorage(userId, storageKey);
}
